import popups from "@/hooks/popups"
import { computed, ref } from "@vue/composition-api"
import axios from "@axios"

export default function contactSourcesListQuery() {

    const { errorToast } = popups()

    const contactSources = ref([])
    const refTable = ref(null)

    // Info
    const total = ref(0)
    const currentPage = ref(1)
    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]

    // Orden
    const sortBy = ref('name')
    const isSortDirDesc = ref(true)

    // Paginación
    const pagination = computed(() => {
        const localItemsCount = refTable.value ? refTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: total.value,
        }
    })

    const tableColumns = ref([
        { key: 'name', label: 'Nombre', sortable: true },
        { key: 'action', label: 'Acciones' }
    ])

    /**
     * Obtener formas de contacto
     */
    const fetchData = async () => {
        await axios.get('/contact-sources', {
            params: {
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value
            }
        })
            .then(response => {
                contactSources.value = response.data.data.data
                total.value = response.data.data.total
            })
            .catch(error => {
                errorToast('Error fetching data list')
            })
    }

    return {
        fetchData,
        contactSources,
        tableColumns,
        pagination,
        sortBy, 
        isSortDirDesc,
        perPage,
        perPageOptions,
        currentPage,
        total,
        refTable
    }

}